import React, { useState, useEffect } from "react";
import YesFb from '../../image/thumbsup.png';
import NoFb from '../../image/thumbsdown.png';
import OMEGA from '../../omega';
import './feedback.scss';
import axios from "axios";
import { URLS } from "../../constants";
function FeedbackForm(props:any) {

 
  const [formData, setFormData] = useState({
    feedback: "",
    description: "",
  });
    const [submit, setSubmit] = useState(false);
   const [close, setClose] = useState(false);
   const [imagesLoaded, setImagesLoaded] = useState(false);

  // Preload images for faster rendering
  useEffect(() => {
    const preloadImages = () => {
      const images = [YesFb, NoFb];
      let loadedCount = 0;
      
      images.forEach((src) => {
        const img = new Image();
        img.onload = () => {
          loadedCount++;
          if (loadedCount === images.length) {
            setImagesLoaded(true);
          }
        };
        img.src = src;
      });
    };
    
    preloadImages();
  }, []);


    const eventDefaultValue = {
    element: "Feedback Form",
    type: "form",
    action: "click",
    widget: {
      name: "Feedback",
      type: "form"
    },
    feature: "Feedback Form Usage"
  }
  function  omega_capture(element:any, widget_name:any, widget_type:any){
     OMEGA.init().updateAndTrack("event", [{
      ...eventDefaultValue,
      element: element,
      widget: {
        name: widget_name,
        type: widget_type
      },
    }]);
  }

  const handleFeedbackClick = (choice:any) => {
    omega_capture("Feedback - Helpful: "+choice, "Feedback Form", "form");
    setFormData({ ...formData, feedback: choice });
  };

  const handleInputChange = (e:any) => {
    if (e.target.value.length <= 1000) {
      setFormData({ ...formData, description: e.target.value });
    }
  };

  const handleSubmit = (e:any) => {
      setSubmit(true);
      omega_capture("Feedback Submitted: Helpful: "+formData.feedback+" Description: "+formData.description, "Feedback Form", "form");
      e.preventDefault();

      const imsProfile:any = sessionStorage.getItem('adobeid_ims_profile');
      const profile:any = JSON.parse(imsProfile);

      // Create a clean data object with only the required fields
      const data: {
        helpful: string;
        feedback: string;
        adobe_id: string;
        email: string;
        conversation_id?: string;
      } = {
        helpful: String(formData.feedback || ''),
        feedback: String(formData.description || ''),
        adobe_id: String(profile?.userId || ''),
        email: String(profile?.email || '')
      };

      // Only include conversation_id if it exists in payload (AI Assistant feedback)
      if (props.payload?.conversationId) {
        data.conversation_id = String(props.payload.conversationId);
      }

      const headers = {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + window.adobeIMS.getAccessToken().token,
      };
      // axios post
      axios.post(URLS.FEEDBACK_URL, data, {headers})
      .then(response => {
        if(response.status >= 200 && response.status < 300){
          props.actionProvider.handleFeedbackSubmit();
          setFormData({ feedback: "", description: "" });
        }else{
          console.error("There was an error submitting the feedback!");
        }
      })
      .catch(error => {
        console.error("There was an error submitting the feedback!", error);
        omega_capture(
          `Error submitting feedback: ${error.message || error.toString()}`,
          "Feedback Form",
          "error"
        );
        props.actionProvider.handleFeedbackFailure();
        setFormData({ feedback: "", description: "" });
      });

     
  };

  return (
<>

    <div  className={submit||close?"feedback-div nodisplay":"feedback-div"}>
    <div className="feedback-header"></div>
        <div className="feedback-cross" onClick={() =>{omega_capture("Feedback Form Closed","Feedback Form", "form");
                                                 setClose(true) }}></div>
     
      {/* <p className="mandatory">*</p> */}
      <p className={"initial-text"}>Did you find what you were looking for?   </p>
      <div className="mandatory">*</div>

      <div className="feedback-button-div">
        <button
          className={formData.feedback==="Yes"?"feedback-button-yes yes-active":"feedback-button-yes"}
          onClick={() => handleFeedbackClick("Yes")}
          disabled={submit}
        >
          <img
            src={YesFb}
            alt="Yes"
            className="feedback-icon"
            loading="eager"
            decoding="sync"
            style={{ opacity: imagesLoaded ? 1 : 0.5 }}
          />
        </button>

        <button
          className= {formData.feedback==="No"?"feedback-button-no no-active":"feedback-button-no"}
          onClick={() => handleFeedbackClick("No")}
          disabled={submit}
        >
          <img
            src={NoFb}
            alt="No"
            className="feedback-icon"
            loading="eager"
            decoding="sync"
            style={{ opacity: imagesLoaded ? 1 : 0.5 }}
          />
        </button>
      </div>
      <form className="form-submit" onSubmit={handleSubmit}>
        {/* <p>Please provide us with feedback to improve your experience</p> */}
        <textarea  className="feedback-textarea"
          placeholder={`Tell us more about your experience  (optional)`} 
          value={formData.description}
          onChange={handleInputChange}
          disabled={submit}
        ></textarea><span className="charcount">
        {formData.description.length}/1000
      </span>
        <button className={submit || formData.feedback===""?"feedback-submit submit-disabled":"feedback-submit"}
          type="submit"
          disabled={submit}
        >
          Submit Feedback
        </button>
      </form>

    </div>
</>
  );
}

export default FeedbackForm;
